module.exports = __webpack_public_path__ + "static/venice20896-bac444ad5787ca31043f19f757e5ac8e.webp";